import type { Draft } from './ui/NewFeedback';

const key = (project: string) => `hoppinger-feedback:draft:${project}`;

/** A half-written report survives a reload. Storage can be missing or full; then it simply is not kept. */
export function loadDraft(project: string): Draft | null {
  try {
    const raw = localStorage.getItem(key(project));
    if (!raw) return null;
    const draft = JSON.parse(raw) as Draft;
    if (!draft || !Array.isArray(draft.blocks) || !draft.blocks.length) return null;
    return draft;
  } catch {
    return null;
  }
}

export function saveDraft(project: string, draft: Draft): void {
  const isEmpty =
    !draft.title.trim() &&
    draft.blocks.every((b) => b.kind === 'text' && !b.html.replace(/<[^>]*>|&nbsp;/g, '').trim());
  try {
    if (isEmpty) {
      localStorage.removeItem(key(project));
      return;
    }
    localStorage.setItem(key(project), JSON.stringify(draft));
  } catch {
    // Screenshots can exceed the storage quota; keep at least the text.
    try {
      const textOnly = { ...draft, blocks: draft.blocks.filter((b) => b.kind === 'text') };
      localStorage.setItem(key(project), JSON.stringify(textOnly));
    } catch {
      // Storage unavailable.
    }
  }
}

export function clearDraft(project: string): void {
  try {
    localStorage.removeItem(key(project));
  } catch {
    // Storage unavailable.
  }
}
